document.addEventListener("DOMContentLoaded", async function () {
    let newPlaceholder = {};

    newPlaceholder.activate = function (el, isFocus = false) {
      if (el.id === "phone" ) {
        return; 
      }
      if (el.value.length > 0 || isFocus ) {
        el.classList.add("has-content");
      } else {
        el.classList.remove("has-content");
      }
    };

    document.querySelectorAll(".form_col_new input, .form_col_new select, .form_col_new textarea").forEach(function (input) {
        newPlaceholder.activate(input);

        input.addEventListener("input", function () {
            newPlaceholder.activate(this);
        });

        input.addEventListener("change", function () {
            newPlaceholder.activate(this);
        });
         input.addEventListener("focus", function () {
            console.log('focus event');
            newPlaceholder.activate(this, true);
        });
        input.addEventListener("blur", function () {
            newPlaceholder.activate(this); // This will remove has-content if no value
        });
    });

    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Function to validate individual input field and show error
    function validateInput(input, errorMessage) {
        const parentDiv = input.closest('.form-main-col');
        const errorContainer = parentDiv.querySelector('.form-error');
        parentDiv.classList.add('error');
        errorContainer.innerHTML = `<p>${errorMessage}</p>`;
    }

    // Function to remove error styling from all inputs on user interaction
    function removeErrorFromAllInputs() {
        const inputs = document.querySelectorAll('input, textarea, select');

        inputs.forEach(input => {
            input.addEventListener('input', () => {
            input.closest('.form-main-col')?.classList.remove('error');
            });
        });
    }

    // Function to validate multiple fields
    function isDomainLike(value) {
        return /(https?:\/\/|www\.)/i.test(value) || /\.[a-z]{2,6}$/i.test(value.trim());
    }

    function validateFields(fields) {
    for (const { field, message } of fields) {
            if (field && field.value.trim() === "" && field.id !== "phone") {
            const errorMessage = field.dataset.error || message;
            validateInput(field, errorMessage);
            field.scrollIntoView({ behavior: "smooth", block: "center" });
            return false;
            }
        }
        return true;
    }

    // Function to get country from phone number using libphonenumber
    function getCountryFromPhoneNumber(phoneNumber, defaultCountry = "US") {
        try {
            // Parse the phone number and use a default country if none is provided
            const phone = libphonenumber.parsePhoneNumberFromString(phoneNumber, defaultCountry);
            if (phone && phone.isValid()) {
            return phone.country;
            } else {
            return 'Invalid phone number';
            }
        } catch (error) {
            return 'Error parsing phone number';
        }
    }

    // Function to add blur validation to form fields
    function addBlurValidation(fields) {
        fields.forEach(({ field, message }) => {
            if (!field) return;

            if (field.tagName.toLowerCase() === 'select') {
                // For select elements, we need to handle both change and blur events
                // Change event: when user selects an option
                // Blur event: when user clicks away without selecting
                
                field.addEventListener('change', () => {
                    const value = field.value;
                    
                    if (value === "" || value === null) {
                        const errorMessage = field.dataset.error || message;
                        validateInput(field, errorMessage);
                    } else {
                        // Remove error styling if field is valid
                        field.closest('.form-main-col')?.classList.remove('error');
                    }
                });

                field.addEventListener('blur', () => {
                    const value = field.value;
                    
                    if (value === "" || value === null) {
                        const errorMessage = field.dataset.error || message;
                        validateInput(field, errorMessage);
                    } else {
                        // Remove error styling if field is valid
                        field.closest('.form-main-col')?.classList.remove('error');
                    }
                });

            } else {
                // For input and textarea elements, use blur event
                field.addEventListener('blur', () => {
                    const value = field.value.trim();

                    // Check for empty field
                    if (field.id != "phone" && value === "") {
                        const errorMessage = field.dataset.error || message;
                        validateInput(field, errorMessage);
                        return;
                    }
                    else if(field.id === "phone" && value === ""){
                        return;
                    }

                    if(field.id === "email"){
                        if (!emailRegex.test(value)) {
                            const errorMessage = field.dataset.formatError || "Email address format not correct";
                            validateInput(field, errorMessage);
                            return;
                        }
                        runEmailValidation(field);
                    }

                    // Phone validation (only for input fields)
                    if (field.id.includes("phone")) {
                        const phoneCodeParent = field.closest('.phone_number_input');
                        const phoneCode = phoneCodeParent.querySelector('.phone_code')?.textContent.trim();
                        let fullPhoneNumber = value.replace(/\s+/g, '');
                        const countryCodeSelect = phoneCodeParent.querySelector('#conatctPhoneCodesSelect');
                        const selectedOption = countryCodeSelect?.options[countryCodeSelect.selectedIndex];
                        const selectedCode = selectedOption?.dataset.phoneCode;

                        if (!fullPhoneNumber.startsWith(phoneCode)) {
                            fullPhoneNumber = phoneCode + fullPhoneNumber;
                        }

                        const isValidPhone = libphonenumber.parsePhoneNumberFromString(fullPhoneNumber, selectedCode);
                        if (!isValidPhone || !isValidPhone.isValid()) {
                            const errorMessage = field.dataset.formatError || "Please enter a valid phone number";
                            validateInput(field, errorMessage);
                            return;
                        }
                    }

                    // Remove error styling if field is valid
                    field.closest('.form-main-col')?.classList.remove('error');
                });
            }
        });
    }

    // Function to populate country codes select dropdown
    function populateCountryCodesSelectContact() {
        const div = document.querySelector('.phone_number_col');
        // This function assumes countryPhoneCodes is available globally
        // You may need to import or define this data separately
        if (typeof countryPhoneCodes === 'undefined') {
            console.warn('countryPhoneCodes is not defined. Please include all-country-phone-codes.js');
            return;
        }

        const phoneCodesSelect = document.querySelector('#phoneCodesSelect');
        const phoneCodeData = countryPhoneCodes;
        const phoneCode = document.querySelector('#phone_code');
        const phoneInput = document.querySelector('#phone');
        const phone = document.querySelector('#phone').value;

        
        const customerCountry = getCountryFromPhoneNumber(phone);

        let foundMatch = false;
        let customerPhoneData = {};

        phoneCodeData.forEach(function(country) {
            const option = document.createElement('option');
            option.value = country.shopifyCode; 
            option.textContent = `${country.country} (${country.code})`;
            option.setAttribute('data-phone-code', country.code);
            // Check if this option matches the customerCountry and set as selected
            if (country.shopifyCode === customerCountry) {
            option.selected = true;
            foundMatch = true;
            customerPhoneData = {
                countryCode: country.shopifyCode,
                code: country.code,
                country: country.country
            }
            }

            phoneCodesSelect.appendChild(option);
        });

        const phoneNumberToAppend = phone.split(customerPhoneData.code);

        if (phoneInput) {
            phoneInput.value = phoneNumberToAppend[phoneNumberToAppend.length - 1];
        }

        

        phoneCodesSelect.addEventListener('change', () => {
            handlePhoneCodeChange(div);
        });

        if (foundMatch) {
            phoneCodesSelect.dispatchEvent(new Event('change'));
        }

        phoneInput.addEventListener('input', (event) => {
          handlePhoneInput(event, div);
        });

        setPhoneNumberProfile(div);
    }


    function handlePhoneCodeChange(div, matchedCountry = null) {
        const selectElement = div.querySelector('.phoneCodesSelect');
        let selectedOption = selectElement.options[selectElement.selectedIndex];
        let selectedValue = selectElement.value;        
        let countryCode = selectedOption.getAttribute('data-phone-code');
        const phoneInput = document.querySelector('#phone');

        if (matchedCountry) {
            const matchingOption = Array.from(selectElement.options).find(option => 
                option.value === matchedCountry.shopifyCode
            );

            if (matchingOption) {
                selectElement.value = matchingOption.value;   
                selectedOption = matchingOption;
                selectedValue = selectElement.value;
                countryCode = selectedOption.getAttribute('data-phone-code');
                selectElement.dispatchEvent(new Event('change'));
            } else {
                console.warn(`No matching option found for: ${matchedCountry.shopifyCode}`);
            }
        }

        const bgFlag = div.querySelector('.bg-flag');
        if (bgFlag && selectedValue) {
            bgFlag.style.backgroundImage = `url(https://cdn.shopify.com/static/images/flags/${selectedValue.toLowerCase()}.svg)`;
        }

        const phoneCodeDisplay = div.querySelector('.phone_code');
        if (phoneCodeDisplay) {
            const oldValue = phoneCodeDisplay.innerHTML;
            phoneCodeDisplay.innerHTML = countryCode; 
            phoneInput?.classList.add("has-content")
            phoneCodeDisplay.setAttribute('data-old-code', oldValue);
        }
    }


    function setPhoneNumberProfile(parentContainer) {
        const phoneInput = parentContainer.querySelector(".phone-number-input");
        const phoneCodeSpan = parentContainer.querySelector(".phone_code");

        let currentPhoneCode = phoneCodeSpan.textContent.trim();

        function updatePhoneNumber() {
            let phoneValue = phoneInput.value.trim();
            console.log("phoneValue", phoneValue);
            const oldCode = phoneCodeSpan.getAttribute('data-old-code')?.trim();
            currentPhoneCode = phoneCodeSpan.textContent.trim();

            if (phoneValue.startsWith(currentPhoneCode)) {
                phoneValue = phoneValue.slice(currentPhoneCode.length).trim();
            }

            if (!phoneValue.startsWith(currentPhoneCode)) {
                phoneInput.value = `${phoneValue}`.trim();
                // phoneInput.dispatchEvent(new Event('input'));
            }
        }

        const observer = new MutationObserver(updatePhoneNumber);
        observer.observe(phoneCodeSpan, { childList: true, subtree: true });
        updatePhoneNumber();
    }

    function detectCountryByPrefix(phoneNumber, phoneContainer) {
    
        const flagSelector = phoneContainer.querySelector('.phone-flex');
        const reversedCountryPhoneCodes = [...countryPhoneCodes].reverse();
        let matchedCountry = reversedCountryPhoneCodes.find(item => phoneNumber.startsWith(item.code));

        // console.log(matchedCountry);
        // console.log(`Detected Country: ${matchedCountry?.country} (${matchedCountry?.shopifyCode})`);

        const parsed = libphonenumber.parsePhoneNumberFromString(phoneNumber);

        if (parsed && parsed.country) {
            // console.log('Detected Country:', parsed.country , parsed);
            matchedCountry = {};
            matchedCountry.shopifyCode = parsed.country;
            handlePhoneCodeChange(phoneContainer, matchedCountry);
            return;
        }

        if(matchedCountry){
        handlePhoneCodeChange(phoneContainer, matchedCountry);
        }

        flagSelector?.classList.add('show');
        
    }


    function handlePhoneInput(event, phoneContainer){
        const phoneNumber = event.target.value;
        const flagSelector = phoneContainer.querySelector('.phone-flex');

        if(phoneNumber.length >= 4){
        detectCountryByPrefix(phoneNumber, phoneContainer);
        flagSelector?.classList.add('show');
        }
        else{
        flagSelector?.classList.remove('show');
        }
    }

    // Function to handle contact form close button
    function handleCloseBtnContactPopup() {
        const body = document.querySelector('body');
        const contactFormPopup = document.querySelector('#contactFormPopup');
        const button = contactFormPopup?.querySelector('.contact-form-submit');

        if (body) {
            body.classList.remove('show-contact-popup');
        }

        const contactForm = document.querySelector('.ContactForm');
        
        if (contactForm) {
            contactForm.reset();
            populateCountryCodesSelectContact();
        }

        if (contactFormPopup) {
            contactFormPopup.classList.remove('hidden-content-show-thankyou');
        }

        if (button) {
            button.classList.remove('show-loader');
        }
    }

    // Main contact form submit function

    let turnstileWidgetIdContact = null;
    let isSubmittingContact = false;

    function handleContactFormSubmit() {
        const contactForm = document.querySelector('.new-contact-form');
        const contactFormPopup = document.querySelector('#contactFormPopup');

        if (!contactForm) {
            console.warn('Contact form not found with selector .new-contact-form');
            return;
        }

        let contactFieldsToValidate = [
            { field: contactForm.querySelector('#first_name'), message: "Enter a first name" },
            { field: contactForm.querySelector('#last_name'), message: "Enter a last name" },
            { field: contactForm.querySelector('#email'), message: "Enter a valid email address" },
            { field: contactForm.querySelector('#phone'), message: "Enter a valid phone number" },
            { field: contactForm.querySelector('#department'), message: "Select a department" },
            { field: contactForm.querySelector('#inquiry'), message: "Enter a message" },
        ];

        // Add blur validation to fields
        addBlurValidation(contactFieldsToValidate);

        // Add radio button validation
        addRadioValidation();

        // Find the submit button by the specified ID
        const submitButton = document.querySelector('#submit-button');

        const contactFormElement = document.querySelector('#new-contact-form');
        
        if (!submitButton) {
            console.warn('Submit button not found with ID #submit-button');
            return;
        }

        // Add click event listener to submit button
        contactFormElement.addEventListener('submit', function(event) {
            console.log('form submit event triggered');
            event.preventDefault(); 
            const deviceType = getDeviceType();

            const formData = new FormData(contactForm);

            if(deviceType === 'mobile'){
                contactFieldsToValidate = [
                    { field: contactForm.querySelector('#first_name'), message: "Enter a first name" },
                    { field: contactForm.querySelector('#last_name'), message: "Enter a last name" },
                    { field: contactForm.querySelector('#email'), message: "Enter a valid email address" },
                    { field: contactForm.querySelector('#phone'), message: "Enter a valid phone number" },
                    { field: contactForm.querySelector('#inquiry'), message: "Enter a message" },
                ];
            }
            
            const phoneCodeElement = document.getElementById('phone_code');
            const phoneNumberElement = document.getElementById('phone');
            
            if (!phoneCodeElement || !phoneNumberElement) {
                console.warn('Phone code or phone number elements not found');
                return;
            }

            const phoneCode = phoneCodeElement.innerHTML;
            const phoneNumber = phoneNumberElement.value;
            const fullPhoneNumber = phoneCode + phoneNumber;

            const isValidContactPhone = libphonenumber.parsePhoneNumberFromString(fullPhoneNumber, phoneCode);

            formData.delete('phone');
            formData.delete('company');
            

            // Validate required fields
            if (!validateFields(contactFieldsToValidate)) {
                return;
            }

            const contactNameFields = [
                { field: contactForm.querySelector('#first_name'), label: 'First name' },
                { field: contactForm.querySelector('#last_name'), label: 'Last name' },
            ];
            for (const { field, label } of contactNameFields) {
                if (field && isDomainLike(field.value.trim())) {
                    validateInput(field, `${label} cannot contain a website or domain name`);
                    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    return;
                }
            }

            // Validate phone number
            if (phoneNumber.trim() !== "" && (!isValidContactPhone || !isValidContactPhone.isValid())) {
                const errorMessage = contactForm.querySelector('#phone').dataset.formatError || "Please enter a valid phone number";
                validateInput(contactForm.querySelector('#phone'), errorMessage);
                contactForm.querySelector('#phone').scrollIntoView({ behavior: "smooth", block: "center" });
                return;
            }

            if(phoneNumber.trim() !== ""){
                formData.append('phone', fullPhoneNumber);
            }

            if(contactForm.querySelector('#company').value.trim() !== ""){
                formData.append('company', contactForm.querySelector('#company').value.trim());
            }

            // Validate email format
            const emailField = contactForm.querySelector('#email');
            if (!emailRegex.test(emailField?.value.trim())) {
                const errorMessage = emailField.dataset.formatError || "Email address format not correct";
                validateInput(emailField, errorMessage);
                emailField.scrollIntoView({ behavior: "smooth", block: "center" });
                return;
            }

            // code to validate terms and conditions checkbox while submit
            const termsCheckbox = contactForm.querySelector('#terms_confirm');

            if (termsCheckbox && !termsCheckbox.checked) {
               
                const errorMesage = document.querySelector('#terms_checkbox .error-message');

                if(errorMesage){
                    errorMesage.classList.remove("hidden");
                    termsCheckbox.classList.add('border-red-500!', 'ring-1!', 'ring-red-500!');
                }

                termsCheckbox.scrollIntoView({ behavior: "smooth", block: "center" });
                return;
            }

            

            const isValidRadio = validateCategoryRadio();

            if (!isValidRadio && deviceType === 'mobile') {
                    return;
                }

            // console.log('Form is valid. Preparing to submit.',  [...formData], 'Device Type:', deviceType);
            


            //Create captcha widget on first submit
            if (turnstileWidgetIdContact === null) {
                turnstileWidgetIdContact = turnstile.render("#turnstile-widget-contact", {
                    sitekey: "0x4AAAAAAB7MX0ml_59yrsx8",
                    theme: 'light',
                    appearance: 'interaction-only',
                    execution: 'execute',
                    callback: function (token) {
                    // This fires when verification succeeds (invisible or after user completes visible challenge)
                    submitFormWithToken(contactForm, token, submitButton);
                    window.dispatchEvent(new CustomEvent('contact_us_submit'));
                    },
                    "error-callback": function () {
                    showToast("Captcha verification failed. Please try again.", "error");
                    },
                    "expired-callback": function () {
                    showToast("Captcha expired. Please verify again.", "error");
                    }
                });
            }

            if (isSubmittingContact) {
                return;
            }

            if (submitButton) {
                submitButton.classList.add('show-loader');
            }

            turnstile.execute('#turnstile-widget-contact');
            isSubmittingContact = true;

            
        });
    }

    function getDeviceType() {
        // Use multiple methods for better compatibility
        const screenWidth = window.innerWidth || 
                        document.documentElement.clientWidth || 
                        document.body.clientWidth || 
                        screen.width;
        
        return screenWidth < 768 ? 'mobile' : 'desktop';
    }

    // function to validate terms and conditions checkbox
    function validateTermsCheckbox() {
        const termsCheckboxContainer = document.querySelector('#terms_checkbox');
        if(termsCheckboxContainer){
            const input = termsCheckboxContainer.querySelector('#terms_confirm');
            input.addEventListener('change', function() {
                
                const errorMesage = termsCheckboxContainer.querySelector('.error-message');
                const submitButton = document.querySelector('#submit-button');

                if(this.checked){
                    if(submitButton && errorMesage){
                        errorMesage.classList.add("hidden");
                        termsCheckboxContainer.classList.remove('border-red-500!', '!ring-1', 'ring-red-500!');
                        submitButton.removeAttribute('disabled');
                    }
                } else {
                    if(submitButton && errorMesage){
                        errorMesage.classList.remove("hidden");
                        termsCheckboxContainer.classList.add('border-red-500!', '!ring-1', 'ring-red-500!');
                        submitButton.setAttribute('disabled', true);
                    }
                }

            });
        }
    }

    validateTermsCheckbox();

    // Add this function to validate radio buttons
    function validateCategoryRadio() {
        const categoryRadioContainer = document.querySelector('.category-radio-container');
        const categoryRadios = document.querySelectorAll('input[name="category_radio"]');
        
        if (!categoryRadioContainer || !categoryRadios.length) return true;
        
        // Check if any radio button is selected
        const isSelected = Array.from(categoryRadios).some(radio => radio.checked);
        
        if (!isSelected && getDeviceType() === 'mobile') {
            categoryRadioContainer.classList.add('show-error');
            return false;
        } else {
            categoryRadioContainer.classList.remove('show-error');
            return true;
        }
    }

    // Add event listeners to radio buttons to remove error on selection
    function addRadioValidation() {
        const categoryRadios = document.querySelectorAll('input[name="category_radio"]');
        
        categoryRadios.forEach(radio => {
            radio.addEventListener('change', function() {
                validateCategoryRadio();
            });
        });
    }

    function submitFormWithToken(contactForm, turnstileToken, submitButton) {
        console.log('Submitting form with Turnstile token:', turnstileToken);
        const formData = new FormData(contactForm);

        const deviceType = getDeviceType();

        const phoneCodeElement = contactForm.querySelector('#phone_code');
        const phoneNumberElement = contactForm.querySelector('#phone');

        const phoneCodesSelectValue = contactForm.querySelector('#phoneCodesSelect')?.value || 'US';

        const phoneCode = phoneCodeElement.innerHTML;
        const phoneNumber = phoneNumberElement.value;

        let fullPhoneNumber = formatPhone(phoneNumber, phoneCode, phoneCodesSelectValue);

        formData.delete('phone');
        formData.delete('company');
        formData.delete('category');
        formData.delete('category_radio');
        formData.delete('cf-turnstile-response');

        if(phoneNumber.trim() !== ""){
            formData.append('phone', fullPhoneNumber);
        }

        if(contactForm.querySelector('#company').value.trim() !== ""){
            formData.append('company', contactForm.querySelector('#company').value.trim());
        }

        let categoryValue = document.querySelector('#department')?.value || 'Sales';

        if(deviceType === 'mobile'){
            categoryValue = document.querySelector('input[name="category_radio"]:checked')?.value || categoryValue;
        }

        formData.append('category', categoryValue);

        formData.append('turnstileToken', turnstileToken);

        // Show loading state
        // if (submitButton) {
        //     submitButton.classList.add('show-loader');
        // }

        // console.log('Form is valid. Ready to submit.',  [...formData]);

        


        // Submit form
        fetch(`${window.API_BASE_URL}/api/contact-form`, {
            method: 'POST',
            body: formData
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
        if (data.status) {
            if (submitButton) {
                submitButton.classList.remove('show-loader');
            }
            manageFormVisibility(true, contactForm);
            
        } else {
            showToast(data.message || "An error occurred. Please try again.", "error");
            manageFormVisibility(false, contactForm);
        }
        })
        .catch(error => {
            console.error('Error:', error);
            showToast(error.message || "An error occurred. Please try again.", "error");
            manageFormVisibility(false, contactForm);
        })
        .finally(() => {
            isSubmittingContact = false;
            
            if (turnstileWidgetIdContact !== null) {
                turnstile.reset('#turnstile-widget-contact');
            }
        });
    }

    function manageFormVisibility(invisible, contactForm) {
        const contactFormThankyouMessage = document.querySelector('.thankyou-message-container');
        const button = contactForm.querySelector('#submit-button');
        
        if(invisible){
            contactForm.classList.add('hidden');
            if(contactFormThankyouMessage){
                contactFormThankyouMessage.classList.remove('hidden');

                // Scroll to thank you message
                contactFormThankyouMessage.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }else{
            contactForm.classList.remove('hidden');
            if(contactFormThankyouMessage) contactFormThankyouMessage.classList.add('hidden');
            contactForm.reset();
            if(button) button.classList.remove('show-loader');
            const inputs = contactForm.querySelectorAll('input, textarea, select');
            inputs.forEach(input => {
                input.dispatchEvent(new Event('input', { bubbles: true }));
            });
        }
    }
    
    // Remove error styling from inputs
    removeErrorFromAllInputs();
    
    // Initialize country codes if the function exists
    if (typeof populateCountryCodesSelectContact === 'function') {
        populateCountryCodesSelectContact();
    }
    
    // Initialize contact form submit handler
    handleContactFormSubmit();



    async function requestValidation(email) {
        const nonce = crypto.randomUUID(); // or any strong random generator
        const response = await fetch('https://email-validator.monitors-com.workers.dev/validate-email', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, nonce }),
        });

        const data = await response.json().catch(() => null);
        return data;
    }

    const showSuggestionButton = (suggestedEmail, input) => {
        const div = input.closest('.form-main-col');
        const err = input.closest('.form-main-col')?.querySelector('.email-suggestion-error');
        if (!err) return;
        const suggestion = input.dataset.suggestion || 'Did you mean';
        err.innerHTML = `${suggestion} <button type="button" class="eav-suggest-btn !p-0 underline !w-auto !leading-none !min-w-0">${suggestedEmail}</button>?`;
        err.classList.add('visible');
        div.classList.add('error');
        err.querySelector('.eav-suggest-btn')?.addEventListener(
        'click',
        async () => {
            input.value = suggestedEmail;
            input.classList.remove('has-error');
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
            validEmail = await runEmailValidation(input);
        },
        { once: true }
        );
    };


    async function runEmailValidation(input) {
        const value = input.value.trim();
        if (!value) return false;

        const container = input.parentElement;

        // --- create and insert loader (do NOT place between input and label) ---
        const spinner = document.createElement("span");
        spinner.className = "email-spinner";
        Object.assign(spinner.style, {
        position: "absolute",
        right: "16px",
        top: "50%",
        width: "16px",
        height: "16px",
        transform: "translateY(-50%)",
        background: "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2216%22 height=%2216%22 viewBox=%220 0 50 50%22><path fill=%22%23aaa%22 d=%22M25.251,6.461c-10.318,0-18.69,8.372-18.69,18.69h4.068c0-8.071,6.551-14.622,14.622-14.622V6.461z%22><animateTransform attributeType=%22xml%22 attributeName=%22transform%22 type=%22rotate%22 from=%220 25 25%22 to=%22360 25 25%22 dur=%220.6s%22 repeatCount=%22indefinite%22/></path></svg>') no-repeat center center",
        backgroundSize: "contain",
        pointerEvents: "none",
        zIndex: "1"
        });

        // append at the end so the immediate-sibling rule (input + label) stays intact
        container.appendChild(spinner);

        // (optional) prevent text from colliding with spinner without affecting label logic
        const origPr = input.style.paddingRight;
        input.style.paddingRight = "1.75rem";

        let suggested = false;

        try {
        const res = await requestValidation(value);

        const suggestionDomain = res?.result?.suggestion ?? res?.suggestion ?? null;
        const score = res?.result?.score ?? res?.score ?? null;

        if (suggestionDomain) {
            const local = res?.result?.local ?? value.split('@')[0] ?? '';
            // fixed template string:
            showSuggestionButton(`${local}@${suggestionDomain}`, input);
            input.classList.add("has-error");
            suggested = true;
        }

        if (typeof score === "number" && score <= 0.3) return false;
        else if (suggested) return "suggested";
        else return true;
        } catch (e) {
        console.error("Email validation error:", e);
        return false;
        } finally {
        // remove spinner and restore padding
        if (spinner && spinner.parentNode === container) container.removeChild(spinner);
        input.style.paddingRight = origPr || "";
        }
    }

    initializeZarazCountryDetection();

      function formatUSCA(number) {
        try {
            const phone = libphonenumber.parsePhoneNumber(number, 'US')
            if (!phone || !phone.isValid()) return number

            const national = phone.formatNational()
            return `+${phone.countryCallingCode} ${national}`
            } catch {
            return number
            }
        }

        // Generic formatter for all countries
        function formatPhone(number, phoneCode, countryCode) {
            try {
            if (phoneCode === '+1') {
                return formatUSCA(number)
            }

            const phone = libphonenumber.parsePhoneNumber(number, countryCode)
            return phone && phone.isValid()
                ? phone.formatInternational()
                : number
            } catch {
            return number
            }
        }





});

function initializeZarazCountryDetection() {
    window.addEventListener("countrychange", function (e) {
        let countryCode = e.detail?.country;
        let stateCode = e.detail?.state;
        
        window.dispatchEvent(new CustomEvent('countryCodeReady', {
            detail: { countryCode, stateCode },
        }));
    }, { once: true });

    window.addEventListener('countryCodeReady', (event) => {
        const countryCode = event?.detail.countryCode;
        populatePhoneCodeFromZaraz(countryCode);
    });
}


function populatePhoneCodeFromZaraz(countryCode) {
    const phoneCodeElement = document.querySelector('#phone_code');
    const bgFlagElement = document.querySelector('.bg-flag');
    
    if (phoneCodeElement) {
        phoneCodeElement.classList.remove('invisible');
    }
    
    if (bgFlagElement) {
        bgFlagElement.classList.remove('invisible');
    }
    if (!countryPhoneCodes) return;
    
    const matched = countryPhoneCodes.find(c => c.shopifyCode === countryCode);
    if (!matched) return;
    
    const phoneSelect = document.querySelector('#phoneCodesSelect');
    
    if (!phoneSelect) return;
    
    const phoneTargetOption = [...phoneSelect.options].find(
        opt => (opt.value || '').trim() === (matched.shopifyCode || '').trim()
    );
    
    if (phoneTargetOption) {
        phoneSelect.value = phoneTargetOption.value;
        
        if (phoneSelect.value.trim()) {
            phoneSelect.classList.add('has-value', 'has-content');
        }
        
        phoneSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
}